import is from './is';

export default {
  is,
};
